// extracted by mini-css-extract-plugin
export default {"imageDesktop":"PromoSlider_imageDesktop__zAP6r","imageMobile":"PromoSlider_imageMobile__TJzW5"};